/** Messages for BFA Admin Portal */
export const LOADING_LIST_MSG = 'Please wait while the data is being loaded';
export const LOADING_UPDATE_MSG = 'Please wait while the data is being updated';
